export interface IPaymentRequest {
  caseLineItemId?: number
  checkNumber?: string
  checkDate?: Date
  checkAmount?: number
  paymentToApply?: number
  payer?: string
}

export class PaymentRequest implements IPaymentRequest {
  public caseLineItemId?: number
  public checkNumber?: string
  public checkDate?: Date
  public checkAmount?: number
  public paymentToApply?: number
  public payer?: string
}
